import React from "react";

import { Creatives } from "reducers/Creatives";
import FilterHeader from "utils/columns/FilterHeader";


export  function FileName({ value }){
	return(
		<div className="creative-filename-col">
			<span title={value} className="name-overflow">{value}</span>
		</div>
	);
}

const FileNameCell = {
	key: "filename",
	name: "File Name",
	filter:"String",
	headerRenderer: (
		<FilterHeader
			Reducer = {Creatives}
			filterSelector = {state => state.creatives.columnFilters.active.filename}
		/>
	),
	formatter:FileName,
	width:110,
	sortable:true,
	resizable:true,
};

export default FileNameCell;
